window.addEventListener('load', () => {
    const mediaPanels = document.querySelectorAll('.media-panel');

    for (const mediaPanel of mediaPanels) {
        const sliders = mediaPanel.querySelectorAll('[data-slider]');
        const sliderHeadings = mediaPanel.querySelectorAll('[data-slider-heading]');
        const sliderToggles = mediaPanel.querySelectorAll('[data-show-slider]');

        if (sliders.length > 1) {
            mediaPanel.addEventListener('click', () => {
                const clickedEventItem = event.target;

                if (clickedEventItem.hasAttribute('data-show-slider')) {
                    const comparisonValue = clickedEventItem.dataset.showSlider;

                    sliderToggles.forEach((sliderToggle) => {
                        if (sliderToggle.dataset.showSlider === comparisonValue) {
                            sliderToggle.dataset.active = 'true';
                        } else {
                            sliderToggle.dataset.active = 'false';
                        }
                    });

                    sliders.forEach((slider) => {
                        if (slider.dataset.slider === comparisonValue) {
                            slider.dataset.active = 'true';
                        } else {
                            slider.dataset.active = 'false';
                        }
                    });

                    sliderHeadings.forEach((heading) => {
                        if (heading.dataset.sliderHeading === comparisonValue) {
                            heading.dataset.active = 'true';
                        } else {
                            heading.dataset.active = 'false';
                        }
                    });
                }
            });
        }

        const mediaVideoSplide  = mediaPanel.querySelector('[data-slider="video"]');

        if (mediaVideoSplide) {
            const videos = mediaPanel.querySelectorAll('video');

            videos.forEach((video) => {
                // Add an event listener for the 'play' event with the 'once' option
                // allows for the video to load the first frame as a preview
                video.addEventListener('play', function () {
                    // Pause the video immediately when it starts autoplaying
                    video.pause();
                    video.removeAttribute('muted');
                }, { once: true });
            });
        }
    }
});